import React from "react";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import NotFound from "../../components/others/NotFound";

export default function NotFoundPage({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <NotFound />
    </Layout>
  );
}
